module.exports = __webpack_public_path__ + "img/t8.cc949eeb.png";